import { Controller } from "@hotwired/stimulus";

// Attached to the layered status-picker Bootstrap Modal that opens from inside
// the mobile reservation detail offcanvas. Two responsibilities:
//
// 1. Set `inert` on the offcanvas behind the modal while the modal is open, so
//    the visible-but-faded detail is non-interactive (no tap, no scroll, no
//    keyboard focus, screen-reader-skipped).
//
// 2. Defensive: re-apply the offcanvas's body-overflow scroll lock after the
//    modal hides. Bootstrap 5.3's ScrollBarHelper reference-counts body
//    `overflow: hidden` across stacked plugins; closing the inner modal can
//    prematurely release the outer offcanvas's lock. Re-applying is a no-op if
//    Bootstrap's bookkeeping is correct, and a fix if it isn't.
//
// See plan docs/plans/2026-05-15-004-fix-mobile-reservation-modal-status-picker-layered-modal-plan.md
export default class extends Controller {
  static values = {
    inertSelector: String,
  };

  setInert() {
    const target = document.querySelector(this.inertSelectorValue);
    if (target) target.setAttribute("inert", "");
  }

  unsetInert() {
    const target = document.querySelector(this.inertSelectorValue);
    if (target) target.removeAttribute("inert");
  }

  restoreScrollLock() {
    // The parent offcanvas is still open — keep body scroll locked.
    document.body.style.overflow = "hidden";
  }
}
